import React from "react";
import { FaShoppingCart } from "react-icons/fa";

export default function Shop(props) {

  return (
    <>
      <div className="icon-button">
        <FaShoppingCart/>
      </div>
    </>
  );
}
